import swal from 'sweetalert';
import {ts} from 'src/utils/translate';

export function genericOKCancelSwal(message, confirmBtnText, callback, failCallback, cancelWord, title, isDelete = false) {
  swal({
    title: title || ts("warning"),
    text: message,
    showCancelButton: true,
    closeOnConfirm: false,
    animation: "slide-from-top",
    inputPlaceholder: "",
    imageUrl: false,
    confirmButtonText: confirmBtnText,
    cancelButtonText: cancelWord || ts("cancel_word", "Cancel"),
    customClass: isDelete ? 'deleteswal' : undefined
  }).then(inputValue => {
    if (inputValue) {
      if (typeof callback == "function")
        callback();
    }
    else {
      if (typeof failCallback == "function") {
        failCallback();
      }
    }
    swal.close();
  });
}

export function genericInputSwal(title, message, checkCallback, errormessage, successCallback) {
  swal({
    html: true,
    title: title,
    text: message,
    type: "input",
    showCancelButton: true,
    closeOnConfirm: false,
    animation: "slide-from-top",
    inputPlaceholder: "",
  }).then(inputValue => {
    if (inputValue === false) return false;

    if (!checkCallback(inputValue)) {
      swal.showInputError(errormessage);
      return false;
    }

    if (successCallback) {
      successCallback(inputValue);
    }

    swal.close();
  });
}

export function genericAlertSwalWithCancelCallback(message, okCallback,
    cancelCallback, okText, cancelText) {
  swal({
    html: true,
    title: ts('warning', 'Warning'),
    text: message,
    showCancelButton: true,
    closeOnConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: okText,
    cancelButtonText: cancelText,
  }, function (inputValue) {
    if (inputValue === true) {
      if (typeof okCallback === "function") {
        okCallback();
      }
    } else {
      if (typeof cancelCallback === "function") {
        cancelCallback();
      }
    }
    swal.close();
  });
}

export function genericAlertSwal(message, okCallback, isDelete = false) {
  swal({
    html: true,
    title: ts('warning', 'Warning'),
    text: message,
    showCancelButton: true,
    closeOnConfirm: false,
    animation: "slide-from-top",
    customClass: isDelete ? 'deleteswal' : undefined
  }, function () {
    if (typeof okCallback === "function") {
      okCallback();
    }
    swal.close();
  });
}

export function genericInfoSwal(title, message, okCallback,
    confirmButtonText = "OK", customClass, allowCloseExceptOK = true) {
  swal({
    allowEscapeKey: allowCloseExceptOK,
    allowOutsideClick: allowCloseExceptOK,
    html: true,
    title: title,
    text: message,
    confirmButtonText: confirmButtonText,
    closeOnConfirm: false,
    animation: "slide-from-top",
    customClass: customClass ? customClass : undefined
  }, function () {
    if (typeof okCallback === "function") {
      okCallback();
    }
    swal.close();
  });
}